<h1 mat-dialog-title>{{ 'SETTINGS.INVITE_HEADING' | translate }}</h1>
<div mat-dialog-content>

    <p>{{ 'SETTINGS.INVITE_MSG' | translate }}</p>
    <div qmap-question [model]="mod" [qMap]="{id:'email', title:'SETTINGS.EMAIL' | translate,type:'shorttext',style:'email',required:true}" ></div>
    <div qmap-question [model]="mod" [qMap]="{id:'message', title:'SETTINGS.MESSAGE' | translate,type:'text'}" ></div>

</div>
<div mat-dialog-actions class="align-content-right">
    <button mat-button (click)="cancel()">{{ 'GENERIC.CANCEL' | translate }}</button>
    <button color="primary" mat-button (click)="ok()" [disabled]="!mod.email?.length" id="invite-user">{{ 'SETTINGS.INVITE' | translate }}</button>
</div>
 